import React from "react";

const PolitiqueSection = ({ title, details }) => {
    return (
        <section className="px-4 sm:p-6 mt-12 mb-12 sm:mb-24 mx-auto max-w-full sm:max-w-xl">
            {/* Titre principal - ajusté pour mobile */}
            <h2 className="text-greenprimary text-2xl sm:text-3xl font-semibold text-center mb-4">
                {title}
            </h2>

            {/* Contenu détaillé - optimisé pour mobile et desktop */}
            <div className="text-gray-700 text-xs sm:text-sm space-y-3 sm:space-y-2">
                {details.map((item, index) => (
                    <p key={index} className="font-light text-left sm:text-center">
                        <span className="font-semibold block sm:inline mb-1 sm:mb-0">{item.label} :</span> {item.value}
                    </p>
                ))}
            </div>
        </section>
    );
};

export default PolitiqueSection;